import { render } from "./committee.vue?vue&type=template&id=7280d78b&scoped=true"
import script from "./committee.vue?vue&type=script&lang=ts"
export * from "./committee.vue?vue&type=script&lang=ts"

import "./committee.vue?vue&type=style&index=0&id=7280d78b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7280d78b"

export default script